import Vue from 'vue'

import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, services } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import form from '@/components/services/registration/form'
import layoutTitle from '@/components/title/layout'

function renderHeader(h) {
  return h(
    layoutTitle,
    {
      props: {
        value: this.getTranslate(`${services.registration}.title`)
      }
    }
  )
}

function renderBody(h) {
  let cardWidth = 450
  if (this.viewport.size.width < 768) {
    cardWidth = 360
  }

  return h(
    components.card,
    {
      class: 'grid pa-3',
      props: {
        outline: true,
        rounded: true,
        overflow: true,
        minWidth: cardWidth,
        maxWidth: cardWidth
      }
    },
    [
      h(
        form,
        {
          props: {
            value: this.payload,
            errors: this.errors
          },
          on: {
            input: event => {
              this.payload = event
            },
            submit: () => {
              this.registration(this.payload)
            },
            validation: event => {
              this.formValidation = event
            }
          }
        }
      ),

      h(
        info,
        {
          props:
          {
            value: this.getTranslate(`${services.registration}.hints.required`),
            color: Colors.info
          }
        }
      )
    ]
  )
}

function renderFooter(h) {
  return h(
    'div',
    {
      class: 'fjcfe grid-gap--8'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate(`${services.registration}.buttons.signin`),
            mode: buttonModes.flat,
            disabled: this.loading,
            name: 'login'
          },
          on: {
            click: () => {
              Vue.router.push({ name: 'login' })
            }
          }
        }
      ),

      h(
        button,
        {
          props: {
            label: this.getTranslate(`${services.registration}.buttons.signup`),
            mode: buttonModes.filled,
            color: Colors.primary,
            loading: this.loading,
            disabled: this.loading || !this.formValidation,
            name: 'registration',
            type: 'submit'
          },
          on: {
            click: () => {
              this.registration(this.payload)
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
